module.exports = __webpack_public_path__ + "img/alicante.1dd88766.jpg";